module.exports = __webpack_public_path__ + "img/sql.190434a7.png";